import GPayButton from "@google-pay/button-react";
import { useGooglePay } from "./contexts/GooglePayContext";
import { useEffect, useRef, useState } from "react";
import { IBreachDetails } from "../../models/breach-details.interface";
import { Typography } from "@mui/material";

interface GooglePayButtonProps {
  amount: number;
  breachDetails: IBreachDetails;
  email: string;
  locale: string;
  disabled?: boolean;
  onClick?: (event: Event) => void;
  setGooglePayLoading: (loading: boolean) => void;
}

const environment =
  process.env.REACT_APP_GOOGLE_PAY_ENVIRONMENT === "production"
    ? "PRODUCTION"
    : "TEST";

export const GooglePayButton = ({
  amount,
  breachDetails,
  email,
  locale,
  disabled,
  onClick,
  setGooglePayLoading,
}: GooglePayButtonProps) => {
  const [creditCardPaymentError, setCreditCardPaymentError] = useState("");
  const { allowedPaymentMethods, handleGooglePayClick } = useGooglePay();
  const googlePayButtonRef = useRef<any>(null);

  const updateButtonStyle = (
    button?: Element | null,
    disabled?: boolean
  ): void => {
    const cursor = disabled === true ? "not-allowed" : "pointer";
    const opacity = disabled === true ? "0.5" : "1";
    button?.setAttribute("style", `cursor: ${cursor}; opacity: ${opacity};`);
  };

  useEffect(() => {
    if (
      googlePayButtonRef.current &&
      googlePayButtonRef.current.manager.element
    ) {
      const button =
        googlePayButtonRef.current.manager.element?.querySelector("button") ||
        googlePayButtonRef.current.manager.element.querySelector(
          '[role="button"]'
        ) ||
        googlePayButtonRef.current.manager.element.firstElementChild;
      updateButtonStyle(button, disabled);
    }
  }, [disabled, googlePayButtonRef.current]);

  return (
    <>
      {allowedPaymentMethods.length > 0 && (
        <>
          <GPayButton
            environment={environment}
            buttonType="pay"
            buttonLocale={locale}
            buttonSizeMode="fill"
            ref={googlePayButtonRef}
            onClick={onClick}
            style={{
              width: "100%",
              height: "50px",
              borderRadius: "10px",
              backgroundColor: "#000",
              color: "#fff",
            }}
            paymentRequest={{
              apiVersion: 2,
              apiVersionMinor: 0,

              allowedPaymentMethods,
              merchantInfo: {
                merchantId: process.env.REACT_APP_GOOGLE_PAY_MERCHANT_ID || "",
                merchantName:
                  process.env.REACT_APP_GOOGLE_PAY_MERCHANT_NAME || "",
              },
              transactionInfo: {
                totalPriceStatus: "FINAL",
                totalPriceLabel: "Total",
                totalPrice: amount.toFixed(2),
                currencyCode:
                  process.env.REACT_APP_GOOGLE_PAY_CURRENCY_CODE || "",
                countryCode:
                  process.env.REACT_APP_GOOGLE_PAY_COUNTRY_CODE || "",
              },
            }}
            onLoadPaymentData={handleGooglePayClick(
              amount,
              breachDetails,
              email,
              setCreditCardPaymentError,
              setGooglePayLoading
            )}
          />
          {creditCardPaymentError && (
            <Typography variant="body1" color="error" mb={1}>
              {creditCardPaymentError}
            </Typography>
          )}
        </>
      )}
    </>
  );
};
